// extracted by mini-css-extract-plugin
export default {"fadeIn":"Nav_fadeIn__gcaWC","container":"Nav_container__WF8j6","arrow":"Nav_arrow__gTQMk","bounce":"Nav_bounce__+OF4v","bounce_frames":"Nav_bounce_frames__ja6cq"};